import { Badge, Stack, Text, Tooltip } from '@mantine/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import useUsers from 'src/admin/users/hooks/useUsers';

dayjs.extend(relativeTime);

const STATUS_CONFIG: Record<string, { variant: string; label: string }> = {
  PENDING: { variant: 'warning', label: 'Pending' },
  CONFIRMED: { variant: 'success', label: 'Confirmed' },
  REJECTED: { variant: 'error', label: 'Rejected' },
  UNLINKED: { variant: 'grey', label: 'Unlinked' },
};

export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] ?? { variant: 'grey', label: status };
  return (
    <Badge variant={config.variant} size="sm">
      {config.label}
    </Badge>
  );
}

function UserName({ userId }: { userId: string | null }) {
  const { users } = useUsers();
  if (!userId) return null;
  const user = users.find(u => u.id === userId);
  return <Text size="xs">{user ? `${user.firstName} ${user.lastName}` : userId}</Text>;
}

export function RelativeTime({ datetime }: { datetime: string | null }) {
  if (!datetime) return null;
  const d = dayjs(datetime);
  return (
    <Tooltip label={d.format('D MMM YYYY, HH:mm')}>
      <Text size="xs" c="dimmed">
        {d.fromNow()}
      </Text>
    </Tooltip>
  );
}

export function ResolvedCell({
  resolvedBy,
  resolvedAt,
}: {
  resolvedBy: string | null;
  resolvedAt: string | null;
}) {
  if (!resolvedAt) return null;
  return (
    <Stack gap={2}>
      <UserName userId={resolvedBy} />
      <RelativeTime datetime={resolvedAt} />
    </Stack>
  );
}
